module.exports = __webpack_public_path__ + "img/小叶莲.f02d58ac.jpg";